import * as tslib_1 from "tslib";
import { PerspectiveProjection } from "@awayjs/core";
import { TraverserBase } from "@awayjs/graphics";
import { TextureProjectorEvent } from "../events/TextureProjectorEvent";
import { DisplayObjectContainer } from "./DisplayObjectContainer";
/**
 * TextureProjector is an object in the scene that can be used to project textures onto geometry. To do so,
 * the object's material must have a ProjectiveTextureMethod method added to it with a TextureProjector object
 * passed in the constructor.
 * This can be used for various effects apart from acting like a normal projector, such as projecting fake shadows
 * unto a surface, the impact of light coming through a stained glass window, ...
 *
 * @see away3d.materials.methods.ProjectiveTextureMethod
 */
var TextureProjector = (function (_super) {
    tslib_1.__extends(TextureProjector, _super);
    /**
     * Creates a new TextureProjector object.
     * @param texture The texture to be projected on the geometry. Since any point that is projected out of the range
     * of the projector's cone is clamped to the texture's edges, the edges should be entirely neutral.
     */
    function TextureProjector(texture) {
        var _this = _super.call(this) || this;
        _this._projection = new PerspectiveProjection();
        _this._projection.transform = _this._transform;
        _this._texture = texture;
        var width = texture.getImageAt(0).width;
        var height = texture.getImageAt(0).height;
        _this._projection.setViewRect(0, 0, width, height);
        _this._projection.setStageRect(0, 0, width, height);
        return _this;
    }
    Object.defineProperty(TextureProjector.prototype, "projection", {
        /**
         *
         */
        get: function () {
            return this._projection;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextureProjector.prototype, "traverseName", {
        get: function () {
            return TextureProjector.traverseName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextureProjector.prototype, "assetType", {
        get: function () {
            return TextureProjector.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextureProjector.prototype, "texture", {
        /**
         * The texture to be projected on the geometry.
         * IMPORTANT: Since any point that is projected out of the range of the projector's cone is clamped to the texture's edges,
         * the edges should be entirely neutral. Depending on the blend mode, the neutral color is:
         * White for MULTIPLY,
         * Black for ADD,
         * Transparent for MIX
         */
        get: function () {
            return this._texture;
        },
        set: function (value) {
            if (value == this._texture)
                return;
            this._texture = value;
            var width = value.getImageAt(0).width;
            var height = value.getImageAt(0).height;
            this._projection.setViewRect(0, 0, width, height);
            this._projection.setStageRect(0, 0, width, height);
            this.dispatchEvent(new TextureProjectorEvent(TextureProjectorEvent.TEXTURE_CHANGE));
        },
        enumerable: true,
        configurable: true
    });
    return TextureProjector;
}(DisplayObjectContainer));
export { TextureProjector };
TextureProjector.traverseName = TraverserBase.addEntityName("applyTextureProjector");
TextureProjector.assetType = "[asset TextureProjector]";



// WEBPACK FOOTER //
// ../dist/lib/display/TextureProjector.js